import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";
import { useTranslation } from "react-i18next";

interface QueryHistoryTabProps {
	queryId: string;
}

export const QueryHistoryTab = ({ queryId }: QueryHistoryTabProps) => {
	const { history, loading, fetchHistory } = useHistoryOperations('query');
	const { t } = useTranslation();

	// Fetch history when component mounts
	useEffect(() => {
		if (queryId) {
			fetchHistory(queryId);
		}
	}, [queryId, fetchHistory]);

	return (
		<div>
			<h3 className="text-lg font-semibold mb-4">{t("queries.history.title", "Query History")}</h3>
			<EntityHistory history={history} loading={loading} />
		</div>
	);
};
